import EmptyList from '@components/EmptyList'
import { Principal } from '@icp-sdk/core/principal'
import { config } from '@plug-core/appConfig'
import { TopUp } from '@plug-core/clients/TopUp'
import useWallet from '@plug-core/hooks/useWallet'
import { TopUp as TopUpItem } from '@plug-core/idls/topUp/topUp'
import { formatNumber } from '@plug-core/utils/formatNumber'
import { ListGroup, ListRow, Spinner, Text } from '@ui'
import { format } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const TopUpHistory = () => {
  const [history, setHistory] = useState<TopUpItem[]>([])
  const [loading, setLoading] = useState(true)

  const { wallet } = useWallet()

  const { t } = useTranslation()

  const loadHistory = async () => {
    setLoading(true)

    const agent = config.getAgent()
    const topUp = new TopUp(agent)
    const historyData = await topUp.getTopUpHistory(Principal.fromText(wallet.principalId))

    setHistory(historyData[0]?.history || [])
    setLoading(false)
  }

  useEffect(() => {
    loadHistory()
  }, [])

  return (
    <div className="mb-3 flex flex-col">
      {loading ? (
        <div className="mt-10 flex justify-center text-fg-2">
          <Spinner size={40} />
        </div>
      ) : history.length ? (
        <ListGroup>
          {history.reverse().map((item, index) => (
            <ListRow
              key={index}
              primary={t(`topup.types.${Object.keys(item.topup_type[0] || { Unknown: null })}`)}
              secondary={
                <Text as="span" variant="mono" className="text-[13px]">
                  {item.canister.toString()}
                </Text>
              }
              trailing={
                <span className="flex flex-col items-end gap-0.5">
                  <Text as="span" weight="semibold" tone="fg" tabular>
                    {formatNumber(Number(item.amount))}
                  </Text>
                  <Text as="span" variant="caption" tone="fg-2" tabular>
                    {format(new Date(Number(item.timestamp) / 1000000), 'dd.MM.yyyy')}
                  </Text>
                </span>
              }
            />
          ))}
        </ListGroup>
      ) : (
        <EmptyList title={t('topupHistory.empty')} />
      )}
    </div>
  )
}
